import { render, staticRenderFns } from "./DashboardRightItem.vue?vue&type=template&id=4b27185b"
import script from "./DashboardRightItem.vue?vue&type=script&lang=js"
export * from "./DashboardRightItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports